import React from 'react';

export default function Title(props: {
    children?: any,
    size?: number
    className?: string
}) {
    let {
        children,
        size = 2,
        className = ''
    } = props;

    const node = `h${size}`;
    const properties = {
        className: `title is-${size} ${className}`
    }

    return React.createElement(node, properties, children);
}
